import React from 'react';

import { flagStyles } from '../settings';

const SvgVG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5640px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgVG;
